import { Row, Text } from '@ydistri/ds';
import { COLORS, computeRemSize } from '@ydistri/theme';
import React from 'react';
import { styled } from 'styled-components';

const Swatch = styled.span<{ $color: string }>`
  display: inline-block;
  width: ${computeRemSize(12)};
  height: ${computeRemSize(12)};
  border-radius: ${computeRemSize(2)};
  background: ${({ $color }) => $color};
`;

/** The row colours of the stores schedule table, the same tokens the DataTable row classes use. */
const items = [
  { color: COLORS.TABLE_HIGHLIGHT_RED, label: 'In effect today' },
  { color: COLORS.TABLE_HIGHLIGHT_ORANGE, label: 'Starts within 7 days' },
];

const StoresScheduleLegend: React.FC = () => (
  <Row $gap="1rem" $alignItems="center">
    {items.map(item => (
      <Row key={item.label} $gap="0.25rem" $alignItems="center">
        <Swatch $color={item.color} />
        <Text $type="light">{item.label}</Text>
      </Row>
    ))}
  </Row>
);

export default StoresScheduleLegend;
